import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import ProtectedRouteSuperDistributor from '../ProtectRouteSuperDistributor';
import ManageClients from 'views/QuicklypayDashboards/Admin/ClientManagement/ManageClients';
import ManageVendors from 'views/QuicklypayDashboards/Admin/VendorManagement/ManageVendor';
import ManageServiceProvider from 'views/QuicklypayDashboards/Admin/ServiceProviderManagement/ManageServiceProvider';
import UploadTransactions from 'views/QuicklypayDashboards/Admin/TransactionUpload/TransactionUpload';
import MoneyFlow from 'views/QuicklypayDashboards/Admin/MoneyFlow/MoneyFlow';

const LandingPage = Loadable(lazy(() => import('views/QuicklypayDashboards/Admin/AdminLandingPage/AdminLandingPage')));
export const QuicklyPayAdminRoutes = {
    path: '',
    children: [
        { path: 'home', element: <ProtectedRouteSuperDistributor element={<LandingPage />} /> },
        { path: 'manage-client', element: <ProtectedRouteSuperDistributor element={<ManageClients />} /> },
        { path: 'manage-vendor', element: <ProtectedRouteSuperDistributor element={<ManageVendors />} /> },
        { path: 'manage-service-provider', element: <ProtectedRouteSuperDistributor element={<ManageServiceProvider />} /> },
        { path: 'upload-transactions', element: <ProtectedRouteSuperDistributor element={<UploadTransactions />} /> },
        { path: 'money-flow', element: <ProtectedRouteSuperDistributor element={<MoneyFlow />} /> }
    ]
};
